// import React, { useEffect, useState } from "react";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { FaStar } from "react-icons/fa";
// import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
// import "./Testimonial.css";
// import Image1 from "../../assets/Testimonial/Vector.png";
// import { getWithoutTokenAPI } from "../../util/Api";
//    import AOS from 'aos';
// import 'aos/dist/aos.css';

// function Testimonial() {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);


//  const useWindowWidth = () => {
//   const [width, setWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     const handleResize = () => setWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return width;
// };

// const width = useWindowWidth();
// let showArrows = false;

// if (width >= 992 && reviews.length > 3) {
//   showArrows = true;
// } else if (width >= 640 && reviews.length > 2) {
//   showArrows = true;
// } else if (width < 640 && reviews.length > 1) {
//   showArrows = true;
// }


// useEffect(() => {
//   AOS.init({
//     duration: 1000, // Animation duration
//     once: true      // Only animate once
//   });
// }, []);

//   useEffect(() => {
//     const fetchReviews = async () => {
//       try {
//         const response = await getWithoutTokenAPI("/review/find-all");
//         if (response?.statusCode === 200) {
//           setReviews(response.data.reviews || []);
//         } else {
//           setError("Failed to fetch reviews");
//         }
//       } catch (error) {
//         console.error("Error fetching reviews:", error);
//         setError("Error loading reviews");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchReviews();
//   }, []);

//   if (loading) {
//     return (
//       <div className="testimonial-container p-5">
//         <div className="container-fluid p-sm-1">
//        <h6
//   className="text-center ff-poppins fs-14 fw-500 fc-green category-title mt-5"
//   data-aos="fade-right"
//   data-aos-delay="100"
// >
//   CLIENT TESTIMONIAL
// </h6>

// <h2
//   className="text-center ff-poppins fs-36 fw-600 category-title-2"
//   data-aos="fade-left"
//   data-aos-delay="200"
// >
//   What our Client Says
// </h2>

//           <div className="text-center">Loading reviews...</div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="testimonial-container">
//         <div className="container-fluid p-5 p-sm-1">
//        <h6
//   className="text-center ff-poppins fs-14 fw-500 fc-green category-title mt-5"
//   data-aos="fade-right"
//   data-aos-delay="100"
// >
//   CLIENT TESTIMONIAL
// </h6>

// <h2
//   className="text-center ff-poppins fs-36 fw-600 category-title-2"
//   data-aos="fade-left"
//   data-aos-delay="200"
// >
//   What our Client Says
// </h2>

//           <div className="text-center text-danger">{error}</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="testimonial-container">
//       <div className="container p-5 p-sm-1">
// {reviews.length > 0 && (
//   <>
//     <h6
//       className="text-center ff-poppins fs-14 fw-500 fc-green category-title mt-5"
//       data-aos="fade-right"
//       data-aos-delay="100"
//     >
//       CLIENT TESTIMONIAL
//     </h6>

//     <h2
//       className="ff-poppins fs-36 fw-600 category-title-2 d-flex justify-content-start text-start"
//       data-aos="fade-left"
//       data-aos-delay="200"
//     >
//       What our Client Says
//     </h2>
//   </>
// )}

      

//         <div className="testimonial-carousel-wrapper position-relative ">

// {reviews.length > 0 && (
// <Swiper
//   modules={[Navigation]}
//   spaceBetween={30}
//   slidesPerView={1}
//   navigation={showArrows ? {
//     nextEl: '.testimonial-next',
//     prevEl: '.testimonial-prev',
//   } : false}
//   breakpoints={{
//     640: { slidesPerView: 2 },
//     992: { slidesPerView: 3 },
//   }}
// >

//     {reviews.map((review) => (
//       <SwiperSlide key={review._id}>
//      <div className="testimonial-card h-100">
//                   <div className="testimonial-content p-4 h-100">
//                     <img src={Image1} alt="testimonial" className="test-quote" />
//                     <p className="testimonial-text ff-poppins fs-14 fw-400">
//                       {review.review}
//                     </p>
//                     <div className="d-flex justify-content-between mt-4 image-star">
//                       <div className="d-flex">
//                         <img
//                           src={review.user_id?.profile_image || "https://via.placeholder.com/50"}
//                           alt={review.user_id?.name || "User"}
//                           className="testimonial-img"
//                         />
//                         <div className="ms-2">
//                           <h6 className="testimonial-name ff-poppins fw-500 fs-16">
//                             {review.user_id?.name || "Anonymous"}
//                           </h6>
//                           <p className="testimonial-role ff-poppins fw-400 fs-14">
//                             {review.product_id?.name || "Product"}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="testimonial-rating mt-2 d-flex">
//                         {[...Array(review.rating || 0)].map((_, i) => (
//                           <FaStar key={i} className="star" />
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//       </SwiperSlide>
//     ))}
//   </Swiper>
// )}

// {showArrows && (
//   <div className="carousel-navigation">
//     <button className="carousel-btn-1 testimonial-prev">
//       <FiChevronLeft className="arrow-icon" />
//     </button>
//     <button className="carousel-btn-2 testimonial-next">
//       <FiChevronRight className="arrow-icon" />
//     </button>
//   </div>
// )}


//         </div>
//       </div>
//     </div>
//   );
// }

// export default Testimonial;


"use client"

import { useEffect, useState } from "react" // Added useCallback for consistency
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import "bootstrap/dist/css/bootstrap.min.css"
import { FaStar } from "react-icons/fa"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"
import "./Testimonial.css"
import Image1 from "../../assets/Testimonial/Vector.png" // Reverted to original import
import { getWithoutTokenAPI } from "../../util/Api"
import AOS from "aos"
import "aos/dist/aos.css"

function Testimonial() {
  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth)
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [])
    return width
  }

  const width = useWindowWidth()

  // FIX: Corrected dynamic showArrows logic based on screen width and reviews count
  // This ensures arrows are only visible if reviews.length exceeds the slidesPerView for the current breakpoint.
  let requiredReviewsForArrows = 0
  if (width >= 992) {
    requiredReviewsForArrows = 3 
  } else if (width >= 640) {
    requiredReviewsForArrows = 2 
  } else {
 
    requiredReviewsForArrows = 1 
  }

  const showArrows = reviews.length > requiredReviewsForArrows

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Only animate once
    })
  }, [])

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await getWithoutTokenAPI("/review/find-all")
        if (response?.statusCode === 200) {
          setReviews(response.data.reviews || [])
        } else {
          setError("Failed to fetch reviews")
        }
      } catch (error) {
        console.error("Error fetching reviews:", error)
        setError("Error loading reviews")
      } finally {
        setLoading(false)
      }
    }
    fetchReviews()
  }, [])

  if (loading) {
    return (
      <div className="testimonial-container p-5">
        <div className="container-fluid p-sm-1">
          <h6
            className="text-center ff-poppins fs-14 fw-500 fc-green category-title mt-5"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            CLIENT TESTIMONIAL
          </h6>
          <h2
            className="text-center ff-poppins fs-36 fw-600 category-title-2"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            What our Client Says
          </h2>
          <div className="text-center">Loading reviews...</div>
        </div>
      </div>
    )
  }
  if (error) {
    return (
      <div className="testimonial-container">
        <div className="container-fluid p-5 p-sm-1">
          <h6
            className="text-center ff-poppins fs-14 fw-500 fc-green category-title mt-5"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            CLIENT TESTIMONIAL
          </h6>
          <h2
            className="text-center ff-poppins fs-36 fw-600 category-title-2"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            What our Client Says
          </h2>
          <div className="text-center text-danger">{error}</div>
        </div>
      </div>
    )
  }
  return (
    <div className="testimonial-container">
      <div className="container p-5 p-sm-1 ">
        {reviews.length > 0 && (
          <>
            <h6
              className="text-center ff-poppins fs-14 fw-500 fc-green category-title mt-5"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              CLIENT TESTIMONIAL
            </h6>
            <h2
              className="ff-poppins fs-36 fw-600 category-title-2 d-flex justify-content-start text-start"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              What our Client Says
            </h2>
          </>
        )}
        <div className="testimonial-carousel-wrapper position-relative ">
          {reviews.length > 0 && (
            <Swiper
              modules={[Navigation]}
              spaceBetween={30}
              slidesPerView={1} // Default for mobile, breakpoints handle others
              navigation={
                showArrows
                  ? {
                      nextEl: ".testimonial-next",
                      prevEl: ".testimonial-prev",
                    }
                  : false
              }
              breakpoints={{
                
                640: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {reviews.map((review) => (
                <SwiperSlide key={review._id}>
                  <div className="testimonial-card h-100">
                    <div className="testimonial-content p-4 mb-2 h-100">
                      <img src={Image1 || "/placeholder.svg"} alt="testimonial" className="test-quote" />
                      <p className="testimonial-text ff-poppins fs-14 fw-400">{review.review}</p>
                      <div className="d-flex justify-content-between mt-4 image-star">
                        <div className="d-flex">
                          <img
                            src={review.user_id?.profile_image || "https://via.placeholder.com/50"}
                            alt={review.user_id?.name || "User"}
                            className="testimonial-img"
                          />
                          <div className="ms-2">
                            <h6 className="testimonial-name ff-poppins fw-500 fs-16">
                              {review.user_id?.name || "Anonymous"}
                            </h6>
                            <p className="testimonial-role ff-poppins fw-400 fs-14">
                              {review.product_id?.name || "Product"}
                            </p>
                          </div>
                        </div>
                        <div className="testimonial-rating mt-2 d-flex">
                          {[...Array(review.rating || 0)].map((_, i) => (
                            <FaStar key={i} className="star" />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          {showArrows && (
            <div className="carousel-navigation">
              <button className="carousel-btn-1 testimonial-prev">
                <FiChevronLeft className="arrow-icon" />
              </button>
              <button className="carousel-btn-2 testimonial-next">
                <FiChevronRight className="arrow-icon" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Testimonial
